import { type OnDemandItem } from "@ca.vmedia.tv/domains";
import { CardDataType, ComponentName, type ISeasonsCardData, type ImageCardData } from "../types";

export class SeasonsCardData implements ISeasonsCardData, ImageCardData{

    private item: OnDemandItem;
    private idx: number;

    constructor(item: OnDemandItem, idx: number) {
        this.item = item;
        this.idx = idx;
    }

    getId(): string {
        return `${this.item.id}`;
    }

    getImage(): string {
        return this.item.image ?? '';
    }

    getItem(): OnDemandItem {
        return this.item;
    }

    getClass(): string {
        return 'seasons-card'
    }

    getType(): CardDataType {
        return CardDataType.OnDemand;
    }

    getContentType(): string {
        return `${this.item.contentType}`;
    }

    getComponentName(): ComponentName {
        return ComponentName.SEASONS;
    }

    getName(): string {
        return this.item.shortName ??  this.item.name ?? this.item.seriesName ?? "";
    }

    getSeasonNumber(): string {
        return this.item.seasonNumber ? `${this.item.seasonNumber}` : `${this.idx}`;
    }
}
